<template>
  <div class="add-card-wrap payway-item" @click="addCardActive">
    <div
      class="payway-row j-add-payway-item"
      :class="{ active: active_payway === 'addCard' }"
    >
      <div class="left">
        <div class="payment-radio"></div>
        <div class="payment-icon" :class="payType"></div>
        <div class="payment-name">{{ letter.addCard }}</div>
      </div>
    </div>
    <div class="payway-detail" v-show="active_payway === 'addCard'">
      <template v-if="!isWPOrAliPay">
        <!-- WorldPay不显示具体信息 -->
        <div class="detail-row card-number">
          <div class="detail-label">{{ letter.cardNum }}</div>
          <div class="input-container card-number" v-if="isCKO">
            <div class="icon-container">
              <div id="icon-card-number" class="input-icon-card-number"></div>
            </div>
            <div class="card-number-frame"></div>
            <div class="icon-container payment-method">
              <div id="logo-payment-method" class="logo-payment-method"></div>
            </div>
            <div class="icon-container">
              <img
                alt="number"
                id="icon-card-number-error"
                src="~@assets/image/cash/card-icons/error.svg"
              />
            </div>
          </div>
          <input
            class="card-input input-item"
            type="text"
            :placeholder="letter.cardNum"
            v-model="form.cardNumber"
            v-if="!isCKO"
          />
          <div class="error-tips" v-if="errorTips['card-number']">
            {{ letter.checkCard }}
          </div>
          <div class="error-tips" v-if="errorTips['unexpected-card']">
            {{ letter.checkCard }}
          </div>
        </div>
        <div class="detail-row expire-and-code">
          <div class="expire-item">
            <div class="detail-label">{{ letter.expireTime }}</div>
            <div class="input-container expiry-date" v-if="isCKO">
              <div class="icon-container">
                <div id="icon-expiry-date" class="input-icon-expiry-date"></div>
              </div>
              <div class="expiry-date-frame"></div>
              <div class="icon-container">
                <img
                  alt="expiry"
                  id="icon-expiry-date-error"
                  src="~@assets/image/cash/card-icons/error.svg"
                />
              </div>
            </div>
            <input
              class="expire-input short-input input-item"
              placeholder="MM/YY"
              v-model="form.expiryDate"
              v-if="!isCKO"
              type="text"
            />
            <div class="error-tips" v-if="errorTips['expiry-date']">
              {{ letter.checkExpiryDate }}
            </div>
            <div></div>
          </div>
          <div class="code-item">
            <div class="detail-label">{{ letter.CVV }}</div>
            <div>
              <div class="input-container cvv" v-if="isCKO">
                <div class="icon-container">
                  <div id="icon-cvv" class="input-icon-cvv"></div>
                </div>
                <div class="cvv-frame"></div>
                <div class="icon-container">
                  <img
                    alt="error"
                    id="icon-cvv-error"
                    src="~@assets/image/cash/card-icons/error.svg"
                  />
                </div>
              </div>
            </div>
            <input
              class="code-input short-input input-item"
              v-if="!isCKO"
              v-model="form.cvv"
              placeholder="CVV"
              type="text"
            />
            <div class="error-tips" v-if="errorTips['cvv']">
              {{ letter.checkCVV }}
            </div>
          </div>
        </div>
        <div class="detail-row select-row">
          <div
            class="select-text"
            :class="{ active: save_payway }"
            @click.stop="toggleSavePayway"
          >
            {{ letter.saveToNext }}
          </div>
        </div>
      </template>
      <div class="error-tips center" v-if="errorTips['pay']">
        {{ letter.checkAllCardMsg }}
      </div>
      <div
        class="pay-btn j-add-card-pay-btn"
        id="pay-button"
        @click="submitCard"
        :class="{ loading: showLoading }"
      >
        <span class="lock-icon"></span>
        <span class="pay-text"
          >{{ letter.neddPay }} {{ getMoneyWithUnit }}</span
        >
        <div class="spiral" v-if="showLoading">
          <div class="spiral-item"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex';
import {
  TOGGLE_SAVE_PAYWAY,
  SET_ACTIVE_PAYWAY,
  PAYMENT_REQUEST_ACTION
} from '@store/officialTopupNew/cash';
import { clickButton } from '@plugins/biPoint/_configWebstoreV35';
export default {
  data() {
    return {
      logos: {
        'card-number': {
          src: 'card',
          alt: 'card number logo'
        },
        'expiry-date': {
          src: 'exp-date',
          alt: 'expiry date logo'
        },
        cvv: {
          src: 'cvv',
          alt: 'cvv logo'
        }
      },
      errorTips: {
        'card-number': false,
        'expiry-date': false,
        'unexpected-card': false,
        cvv: false,
        pay: false
      },
      showLoading: false,
      form: {
        cardNumber: '',
        expiryDate: '',
        cvv: ''
      }
    };
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      active_payway: state => state.cash.active_payway,
      save_payway: state => state.cash.save_payway,
      order_id: state => state.cash.order_id,
      user_pay_infos: state => state.cash.user_pay_infos,
      f_pay_type: state => state.cash.f_pay_type,

      payType: state => state.cash.pay_type
    }),
    ...mapGetters(['isCKO', 'isWPOrAliPay', 'getMoneyWithUnit']),
    isProduct() {
      return this.$store.state.cash.config_key === 'product';
    }
  },
  methods: {
    toggleSavePayway() {
      clickButton({
        btnName: 'save_credit_card'
      });
      this.$store.commit(TOGGLE_SAVE_PAYWAY);
    },
    addCardActive() {
      if (this.active_payway !== 'addCard') {
        window.webstorev35DataLayer.push({
          eventName: 'select_credit',
          eventType: 'new_credit_card'
        });
      }
      this.$store.commit(SET_ACTIVE_PAYWAY, 'addCard');
    },
    clearTips() {
      const inputArr = ['card-number', 'expiry-date', 'cvv', 'pay'];
      inputArr.forEach(item => (this.errorTips[item] = false));
    },
    checkForm() {
      //  WP无需校验直接可提交
      if (this.isWPOrAliPay) {
        return true;
      }
      // 如果是CKO，则利用Frame校验卡信息，
      if (this.isCKO && !Frames.isCardValid()) {
        this.errorTips['pay'] = true;
        return false;
      }
      // 如果CKO，但是为非限制卡号
      if (this.errorTips['unexpected-card']) {
        return false;
      }
      // 如果不是CKO和WP，则利用正则校验卡信息
      if (!this.isCKO && !this.isWPOrAliPay) {
        const cardNumberReg = /^\d{13,19}$/;
        const expiryDateReg = /^\d{2}\/\d{2}$/;
        const cvvReg = /^\d{3,4}$/;
        if (!cardNumberReg.test(this.form.cardNumber)) {
          this.errorTips['card-number'] = true;
          return false;
        }
        if (!expiryDateReg.test(this.form.expiryDate)) {
          this.errorTips['expiry-date'] = true;
          return false;
        }
        if (!cvvReg.test(this.form.cvv)) {
          this.errorTips['cvv'] = true;
          return false;
        }
      }
      this.clearTips();
      return true;
    },
    async submitCard() {
      // 是否Loading中
      if (this.showLoading) {
        return;
      }
      // 校验表单
      if (!this.checkForm()) {
        return;
      }
      const commitData = {
        source_type: 'token'
      };
      this.showLoading = true;
      // 如果是CKO，则先获取token,并带上token提交
      if (this.isCKO) {
        const frameRes = await Frames.submitCard();
        commitData.token = frameRes.token;
      }
      clickButton({
        btnName: 'click-pay-btn'
      });
      await this.$store.dispatch(PAYMENT_REQUEST_ACTION, commitData);
    }
  },
  mounted() {
    // 如果不是checkout则不加载Frame
    if (!this.isCKO) {
      return;
    }
    // 根据config_key参数判断当前的key种类
    const SANDBOX_KEY = 'pk_sbox_yby6beba44h52ica2krm4qp7ce2';
    const PRODUCT_KEY = 'pk_lhshyxsyoveignxqidgxbjdvjam';
    const framesPayTypeMap = {
      visa: 'Visa',
      master: 'Mastercard',
      amex: 'American Express',
      diners: 'Diners Club',
      discover: 'Discover',
      jcb: 'JCB'
    };
    /* global Frames */
    const payButton = document.getElementById('pay-button');
    // public API key within the brackets.
    // Init方法需根据paytype类型来限制当前的卡种，若不在framesPayTypeMap的氛围里，则不限制传[]
    Frames.init({
      publicKey: this.isProduct ? PRODUCT_KEY : SANDBOX_KEY,
      acceptedPaymentMethods: framesPayTypeMap[this.payType]
        ? [framesPayTypeMap[this.payType]]
        : [],
      localization: {
        cardNumberPlaceholder: 'Card Number',
        expiryMonthPlaceholder: 'MM',
        expiryYearPlaceholder: 'YY',
        cvvPlaceholder: 'CVV'
      },
      style: {
        base: {
          fontFamily: 'tahoma, arial, Hiragino Sans GB, sans-serif',
          letterSpacing: '0.6px'
        }
      }
    });
    Frames.addEventHandler(Frames.Events.FRAME_FOCUS, event => {
      window.webstorev35DataLayer.push({
        eventName: 'input_cardinfo',
        eventType: 'new_credit_card',
        eventReason: event.element
      });
    });
    Frames.addEventHandler(Frames.Events.FRAME_VALIDATION_CHANGED, event => {
      const e = event.element;
      if (event.isValid || event.isEmpty) {
        if (e === 'card-number' && !event.isEmpty) {
          showPaymentMethodIcon();
        }
        setDefaultIcon(e);
        clearErrorIcon(e);
        this.clearTips();
        return;
      }
      if (e === 'card-number') {
        clearPaymentMethodIcon();
      }
      setDefaultErrorIcon(e);
      setErrorIcon(e);
      if (!this.errorTips['unexpected-card']) {
        this.errorTips[e] = true;
      }
    });

    Frames.addEventHandler(Frames.Events.CARD_VALIDATION_CHANGED, () => {
      payButton.disabled = !Frames.isCardValid();
    });

    Frames.addEventHandler(Frames.Events.CARD_TOKENIZATION_FAILED, error => {
      console.log('CARD_TOKENIZATION_FAILED:%o', error);
      Frames.enableSubmitForm();
    });

    Frames.addEventHandler(Frames.Events.PAYMENT_METHOD_CHANGED, event => {
      this.errorTips['unexpected-card'] = !event.isPaymentMethodAccepted;
    });

    Frames.addEventHandler(Frames.Events.PAYMENT_METHOD_CHANGED, event => {
      const pm = event.paymentMethod;
      let container = document.querySelector('.icon-container.payment-method');
      if (!pm) {
        clearPaymentMethodIcon(container);
        return;
      }
      clearErrorIcon('card-number');
      showPaymentMethodIcon(container, pm);
    });
    const clearErrorIcon = el => {
      const logo = document.getElementById('icon-' + el + '-error');
      logo.style.removeProperty('display');
    };

    const showPaymentMethodIcon = (parent, pm) => {
      parent && parent.classList.add('show');

      const logo = document.getElementById('logo-payment-method');

      if (pm) {
        const name = pm.toLowerCase().replace(' ', '-');
        logo.classList.remove(
          'error',
          'discover',
          'jcb',
          'mada',
          'maestro',
          'mastercard',
          'american-express',
          'diners-club',
          'visa'
        );
        logo.classList.add(name);
        logo.setAttribute('src', 'images/card-icons/' + name + '.svg');
      }
      logo.style.removeProperty('display');
    };

    const clearPaymentMethodIcon = parent => {
      parent && parent.classList.remove('show');

      const logo = document.getElementById('logo-payment-method');
      logo.style.setProperty('display', 'none');
    };

    const setDefaultIcon = el => {
      const selector = 'icon-' + el;
      const logo = document.getElementById(selector);
      logo.classList.remove('error');
      logo.setAttribute('alt', this.logos[el].alt);
    };

    const setDefaultErrorIcon = el => {
      const selector = 'icon-' + el;
      const logo = document.getElementById(selector);
      logo.classList.add('error');
    };

    const setErrorIcon = el => {
      const logo = document.getElementById('icon-' + el + '-error');
      logo.style.setProperty('display', 'block');
    };
  }
};
</script>
